import { render, staticRenderFns } from "./ApprovePreviewLetterPage.vue?vue&type=template&id=b421acfc&scoped=true&"
import script from "./ApprovePreviewLetterPage.vue?vue&type=script&lang=js&"
export * from "./ApprovePreviewLetterPage.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePreviewLetterPage.vue?vue&type=style&index=0&id=b421acfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b421acfc",
  null
  
)

export default component.exports